(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elvaya-bridal-edit"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elvaya-bridal-edit'))customElements.define('elvaya-bridal-edit',class extends HTMLElement{
connectedCallback(){this.abort=new AbortController();this.rail=this.querySelector('.elvaya-bridal-edit__rail');this.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>{this.rail.scrollBy({left:Number(button.dataset.direction)*this.rail.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});},{signal:this.abort.signal}));}
disconnectedCallback(){this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elvaya-collection-tabs"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elvaya-collection-tabs'))customElements.define('elvaya-collection-tabs',class extends HTMLElement{
  connectedCallback(){this.abort=new AbortController();this.tabs=[...this.querySelectorAll('[role="tab"]')];this.panels=[...this.querySelectorAll('[role="tabpanel"]')];this.select=(index,focus=false)=>{this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index;});if(focus)this.tabs[index].focus();};this.tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>this.select(index),{signal:this.abort.signal});tab.addEventListener('keydown',event=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;else if(event.key==='ArrowLeft')next=(index+this.tabs.length-1)%this.tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.tabs.length-1;else return;event.preventDefault();this.select(next,true);},{signal:this.abort.signal});});}
  disconnectedCallback(){this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elvaya-comfort-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-elvaya-hero]').forEach(root=>{let current=0;const slides=root.querySelectorAll('[data-hero-slide]'),dots=root.querySelectorAll('[data-hero-dot]');function show(i){current=(i+slides.length)%slides.length;slides.forEach((slide,n)=>slide.hidden=n!==current);dots.forEach((dot,n)=>dot.setAttribute('aria-pressed',String(n===current)));}root.querySelector('[data-hero-prev]').addEventListener('click',()=>show(current-1));root.querySelector('[data-hero-next]').addEventListener('click',()=>show(current+1));dots.forEach((dot,n)=>dot.addEventListener('click',()=>show(n)));});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elvaya-product-details"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elvaya-product-details'))customElements.define('elvaya-product-details',class extends HTMLElement{connectedCallback(){this.abort=new AbortController();const tabs=[...this.querySelectorAll('[role=tab]')],panels=[...this.querySelectorAll('[role=tabpanel]')];const select=(n,focus)=>{tabs.forEach((t,i)=>{t.setAttribute('aria-selected',String(i===n));t.tabIndex=i===n?0:-1;panels[i].hidden=i!==n;});if(focus)tabs[n].focus();};tabs.forEach((t,i)=>{t.addEventListener('click',()=>select(i,false),{signal:this.abort.signal});t.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();select(n,true);},{signal:this.abort.signal});});}disconnectedCallback(){this.abort?.abort();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elvaya-sale-slider"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elvaya-sale-slider')){
customElements.define('elvaya-sale-slider',class extends HTMLElement{
connectedCallback(){
this.track=this.querySelector('.elvaya-sale-slider__track');this.slides=[...this.track.children];this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
this.abort=new AbortController();const opts={signal:this.abort.signal};
this.syncHeight=()=>{this.track.style.height=this.slides[this.index].getBoundingClientRect().height+'px';};
this.observer=new ResizeObserver(()=>this.syncHeight());this.slides.forEach(slide=>this.observer.observe(slide));this.syncHeight();
this.go=(i)=>{this.index=(i+this.slides.length)%this.slides.length;this.syncHeight();this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:'smooth'});this.querySelector('[data-status]').textContent=(this.index+1)+' / '+this.slides.length;};
this.querySelector('[data-next]').addEventListener('click',()=>this.go(this.index+1),opts);
this.querySelector('[data-prev]').addEventListener('click',()=>this.go(this.index-1),opts);
this.querySelector('[data-pause]').textContent=this.paused?'Play':'Pause';
this.querySelector('[data-pause]').addEventListener('click',()=>{this.paused=!this.paused;this.querySelector('[data-pause]').textContent=this.paused?'Play':'Pause';this.querySelector('[data-pause]').setAttribute('aria-label',this.paused?'Play slideshow':'Pause slideshow');},opts);
this.track.addEventListener('scroll',()=>{this.index=Math.round(this.track.scrollLeft/this.track.clientWidth);this.syncHeight();this.querySelector('[data-status]').textContent=(this.index+1)+' / '+this.slides.length;},opts);
this.timer=setInterval(()=>{if(!this.paused&&!document.hidden&&!this.matches(':hover')&&!this.contains(document.activeElement))this.go(this.index+1);},6000);
}
disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this.abort?.abort();}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elvaya-style-edit"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elvaya-style-edit'))customElements.define('elvaya-style-edit',class extends HTMLElement{
  connectedCallback(){this.abort=new AbortController();this.tabs=[...this.querySelectorAll('[role="tab"]')];this.panels=[...this.querySelectorAll('[role="tabpanel"]')];this.select=(index,focus=false)=>{this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index;});if(focus)this.tabs[index].focus();};this.tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>this.select(index),{signal:this.abort.signal});tab.addEventListener('keydown',event=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;else if(event.key==='ArrowLeft')next=(index+this.tabs.length-1)%this.tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.tabs.length-1;else return;event.preventDefault();this.select(next,true);},{signal:this.abort.signal});});}
  disconnectedCallback(){this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
